/* eslint-disable react/prop-types */
import React from 'react'
import LinkIcon from '@material-ui/icons/Link'
import CallIcon from '@material-ui/icons/Call'
import Button from '@material-ui/core/Button'
import { usePermissions } from 'react-admin'

const MyPhonerUrl = 'https://zappyrent.myphoner.com/work/leads'
const PipedriveDealsUrl = process.env.REACT_APP_PIPEDRIVE_URL

const ToolbarButtons = ({ data }) => {
  const { permissions } = usePermissions()

  return (
    <>
      {data && permissions?.canGoToMyPhoner && data.my_phoner_id > 0 && (
        <Button color="primary" target="_blank" href={`${MyPhonerUrl}/${data.my_phoner_id}`} startIcon={<LinkIcon />}>
          Go to MyPhoner
        </Button>
      )}
      {data && permissions?.canGoToPipedrive && data.pipedrive_id > 0 && (
        <Button color="primary" target="_blank" href={`${PipedriveDealsUrl}/${data.pipedrive_id}`} startIcon={<CallIcon />}>
          Go to Pipedrive
        </Button>
      )}
    </>
  )
}

export default ToolbarButtons
